import { render, staticRenderFns } from "./WorkshopEditClient.vue?vue&type=template&id=52520565&"
import script from "./WorkshopEditClient.vue?vue&type=script&lang=ts&"
export * from "./WorkshopEditClient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports